module.exports = __webpack_public_path__ + "static/media/lightning-dark.75d3578d.svg";